import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { DataTableUtilities } from '@app/core/utilities/data-table-utilities';
import { OverrideColumnDefinition, OverrideColumnParameters } from '@app/search/gridOptions/search-grid-options-formatter';
import { SampleSearchColumnFields, SampleSearchGridOptionsFormatter } from '@app/search/gridOptions/sample-search-grid-options-formatter';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { HttpClient } from '@angular/common/http';
import { RadLinkRendererComponent } from '@app/shared/cell-renderers/rad-link-renderer/rad-link-renderer.component';

export class SampleChooserGridOptionsFormatter extends SampleSearchGridOptionsFormatter {
  constructor(
      public resourceDictionaryService: SearchResourceDictionaryService,
      public bsshDatePipe: BsshDatePipe,
      public http: HttpClient
  ) {
      super(resourceDictionaryService, bsshDatePipe, http);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<SampleSearchColumnFields> {
      const inclusiveColumns: SampleSearchColumnFields[] = [
          SampleSearchColumnFields.Name,
          SampleSearchColumnFields.Created,
          SampleSearchColumnFields.Owner,
          SampleSearchColumnFields.Project,
          SampleSearchColumnFields.Size,
          SampleSearchColumnFields.ReadLength1,
          SampleSearchColumnFields.ReadLength2,
          SampleSearchColumnFields.NumReadsPF,
          SampleSearchColumnFields.Genome
        ];

      const overrideColumnDefinitions: OverrideColumnDefinition<SampleSearchColumnFields>[] = [
        {
          headerName: 'Name',
          field: 'Sample.Name',
          cellRendererFramework: RadLinkRendererComponent,
          cellRendererParams: (params) => {
            if(params.data) {
              const tooltipText = !this.isRowSelectable(params.node) ? this.getUnselectableRowMessage(params.node) : null;
              return DataTableUtilities.getRadLinkParams(
                params.data.Sample.Name,
                this.resourceConfig.uiHrefAccessor(params.data),
                tooltipText,
                null,
                60
              );
            } else {
              return {};
            }
          },
          colId: SampleSearchColumnFields.Name,
          showAlways: true,
          sortable: false,
          filterActive: false,
        }
      ];

      return {
          inclusiveColumns,
          overrideColumnDefinitions
      };
  }
}